import {createStore} from 'vuex';

const store = createStore({
    state() {
        return {
            cache: {
                view_content: {},
            },
            next_fields: null,
            theme: '',
            version: '',
            listings: null,
            transitioning: false,
            impressionTracker: {},
            griddleActive: false,
            baseUrl: process.env.BASE_URL[process.env.BASE_URL.length - 1] === '/' ? process.env.BASE_URL.slice(0, -1) : process.env.BASE_URL
        }
    },
    mutations: {
        setViewCache(state, {url, templateString, context, fields, reviews, listings}) {
            url = url?.split('?')[0]
            if (state.cache.view_content[url]) {
                clearTimeout(state.cache.view_content[url]?.ttl)
            }
            state.cache.view_content[url] = {
                content: templateString,
        ttl: setTimeout(() => { delete state.cache.view_content[url] }, 240000),
                fields,
                context,
                reviews,
                listings
            };
        },
        removeViewCache(state, url) {
            if(state.cache.view_content?.[url]) {
                delete state.cache.view_content[url]
            }
        },
        setFields(state, {view, fields}) {
            const v = view[0] !== '/' ? '/' + view : view;
            if (state.cache.view_content[v]) {
                state.cache.view_content[v].fields = fields;
            }
        },
        setNextFields(state, fields) {
            state.next_fields = fields;
        },
        setTheme(state, theme) {
            state.theme = theme;
        },
        setVersion(state, version) {
            state.version = version;
        },
        setListings(state, listings) {
            state.listings = listings;
        },
        setTransitioning(state, transitioning = false) {
            state.transitioning = transitioning
        },
        setImpressionTracking(state, {key, value}) {
            state.impressionTracker[key] = value;
        },
        setGriddleActive(state, active) {
            state.griddleActive = active;
        }
    },
    actions: {},
    getters: {
        getCachedView: (state) => (path) => {
            return state.cache.view_content[path];
        },
        getNextFields: (state) => state.next_fields,
        getTheme: (state) => state.theme,
        getVersion: (state) => state.version,
        getListing: (state) => Object.keys(state.listings || {})?.length ? state.listings : null,
        isTransitioning: state => state.transitioning,
        getCachedFields: state => path => {
            const v = path[0] !== '/' ? '/' + path : path;
            return state.cache.view_content?.[v]?.fields
        },
        getImpressionTracking: state => key => {
            return state.impressionTracker[key];
        },
        getGriddleActive: state => state.griddleActive,
        getBaseUrl: state => state.baseUrl
    }

})

export default store